import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { AuthLayout } from '../../../components/generic/Layouts/AuthLayout'
import { Eyebrow } from '../../../components/generic/ui/Eyebrow'
import { AuthHeading } from '../../../components/generic/ui/Heading'
import { TextInput, PasswordInput } from '../../../components/generic/ui/Input'
import { AccentButton } from '../../../components/generic/ui/Button'
import OtpCodeInput from '../../../components/generic/ui/otp-code-input/OtpCodeInput'
import { UseRegisterFormReturn } from './RegisterForm.types'

export const RegisterFormView: React.FC<UseRegisterFormReturn> = (p) => (
  <AuthLayout>
    <Eyebrow>AGROLINE / SIGN UP</Eyebrow>
    {p.isShowSmsStep ? (
      <>
        <AuthHeading subtitle={`שלחנו קוד SMS למספר ${p.tel}`}>
          אימות<br />טלפון
        </AuthHeading>
        <Form onSubmit={(e) => { e.preventDefault(); p.verifySMS() }}>
          <OtpCodeInput
            length={4}
            onCodeChange={p.handleCodeSms}
            label="הזן את הקוד שקיבלת ב-SMS"
            autoFocus
          />
          <AccentButton
            type="submit"
            disabled={p.isAwaitingCodeVerifying || p.codeSMS.length !== 4}
          >
            {p.isAwaitingCodeVerifying ? 'מאמת...' : 'אמת קוד'}
          </AccentButton>
          <AccentButton type="button" variant="ghost" onClick={p.cancelSmsStep}>
            חזרה
          </AccentButton>
        </Form>
      </>
    ) : (
      <>
        <AuthHeading subtitle="ברוכים הבאים — בואו נתחיל">
          הרשמה<br />למערכת
        </AuthHeading>
        <Form onSubmit={p.handleSubmit}>
          <TextInput
            label="שם משתמש"
            name="username"
            type="text"
            placeholder="moshe.cohen"
            autoComplete="off"
            value={p.userName}
            onChange={p.handleUserName}
            error={p.isExistUserName ? 'שם משתמש תפוס' : undefined}
            required
          />

          <PasswordInput
            label="סיסמה"
            name="password"
            placeholder="••••••••"
            autoComplete="new-password"
            value={p.password}
            onChange={p.handlePassword}
            error={
              p.password && !p.isPasswordValid
                ? 'סיסמה חייבת להכיל לפחות ספרה ואות (4+)'
                : undefined
            }
            required
          />

          <PasswordInput
            label="לאשר את הסיסמה"
            name="confirmPassword"
            placeholder="••••••••"
            autoComplete="new-password"
            value={p.confirmPassword}
            onChange={p.handleConfirmPassword}
            error={p.isPasswordMismatch ? 'סיסמאות לא תואמות' : undefined}
            required
          />

          <TextInput
            label="טלפון נייד"
            name="phone"
            type="tel"
            placeholder="0501234567"
            inputMode="numeric"
            value={p.tel}
            onChange={p.handleTelephone}
            disabled={p.isMatchCode}
            helperText={
              !p.isMatchCode
                ? `נשארו ${p.restDigits} ספרות`
                : 'הטלפון אומת בהצלחה'
            }
          />

          {!p.isMatchCode ? (
            <AccentButton
              type="button"
              onClick={p.sendSms}
              disabled={!p.isAllowSendSms}
            >
              בדיקת תקפות הטלפון
            </AccentButton>
          ) : (
            <AccentButton
              type="submit"
              disabled={!p.isAllowRegister}
            >
              הרשמה
            </AccentButton>
          )}

          <BottomRow>
            <Link to={p.inviteToken ? `/login?token=${p.inviteToken}` : '/login'}>כניסה</Link>
          </BottomRow>
        </Form>
      </>
    )}
  </AuthLayout>
)
RegisterFormView.displayName = 'RegisterFormView'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

const BottomRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  font-size: 0.8125rem;

  a {
    color: ${({ theme }) => theme.colors.ink2};
    text-decoration: none;
    font-weight: 500;
    border-bottom: 1px solid transparent;
    transition: border-color ${({ theme }) => theme.motion.fast},
      color ${({ theme }) => theme.motion.fast};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.ink};
    border-bottom-color: ${({ theme }) => theme.colors.ink};
  }
`

export default RegisterFormView
